<template>
	<transition-group name="enterRight" tag="div" class="zw-popup-container">
		<div class="ui compact floating zw-popup message" v-for="(alert, index) in alerts" :key="alert.id" :class="alert.type" :style="findAlign(alert.align)">
			<i class="close icon" @click="closeAlert(0, index, 'click')" v-if="!alert.closebutton === false || alert.closebutton === undefined"/>
			<div class="header" v-html="alert.header"></div>
      <p v-html="alert.message" v-if="alert.message"/>
		</div>
	</transition-group>
</template>

<script>
	import findIndex from 'lodash/findIndex'
  import uniqueId from 'lodash/uniqueId'

	export default {
		name: 'Alert',

		data () {
			return {
				alerts: [],
				closeMessageTimeout: null
			}
		},

		watch: {
		},

		mounted () {
			this.$events.$on('alert', (data) => {
        if (data.message) {
          if (!data.id) {
            data.id = uniqueId('alert-')
          }
          this.alerts.push(data)
					this.closeAlert(data.timer, data)
				}
			})
		},

		methods: {
			closeAlert (timer = 5000, alertData, eventType = 'auto') {
				switch (eventType) {
					case 'auto':
						if (timer !== 0) {
							this.closeMessageTimeout = setTimeout(() => {
								this.alerts.splice(findIndex(this.alerts, alertData), 1)
							}, timer)
						}
						break
					case 'click':
						this.alerts.splice(alertData, 1)

						if (this.closeMessageTimeout) {
							clearTimeout(this.closeMessageTimeout)
							this.closeMessageTimeout = null
						}
						break
				}
			},

			findAlign (align) {
				let returnVariable = ''

				switch (align) {
					case 'left':
						returnVariable = 'align-self: flex-start;'
						break
					case 'right':
						returnVariable = 'align-self: flex-end;'
						break
					case 'center':
						returnVariable = 'align-self: center; text-align: center;'
						break
				}

				return returnVariable
			}
		},

		beforeDestroy () {
			this.$events.$off('alert')
		}
	}
</script>

<style lang="scss" scoped>
	.zw-popup-container {
		position: fixed;
		align-self: flex-start;
		width: 100%;
		display: flex;
		align-items: center;
		justify-content: center;
		flex-flow: column;
		z-index: 2000;
		top: 0;
		left: 0;

		pointer-events: none;

		.zw-popup {
			position: relative;
			z-index: 1000000000;
			margin: 15px 15px 0px 15px;
			min-width: 250px;
			pointer-events: auto;
		}
	}

	.enterRight-enter-active, .enterRight-leave-active {
		transition: all .15s ease;
		transform: translateX(0)
	}
	.enterRight-enter, .enterRight-leave-to {
		top: -5px;
		opacity: 0;
		transform: translateX(100%)
	}
</style>





// WEBPACK FOOTER //
// src/components/notifications/Alert.vue